import { render, staticRenderFns } from "./zzl-visual-editor.vue?vue&type=template&id=3f65b9fd&scoped=true"
import script from "./zzl-visual-editor.vue?vue&type=script&lang=js"
export * from "./zzl-visual-editor.vue?vue&type=script&lang=js"
import style0 from "./zzl-visual-editor.vue?vue&type=style&index=0&id=3f65b9fd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f65b9fd",
  null
  
)

export default component.exports